import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import { App } from './App.tsx'
import { QueryProvider } from './providers/QueryProvider'
import { APP_ICON_DIR, IS_PROD, LOGO_SRC } from './lib/env'
import { initSentry } from './lib/sentry'
import { registerPreloadErrorReload } from './lib/reloadOnPreloadError'
import { registerPwa } from './lib/pwa/registerPwa'

initSentry()

if (!IS_PROD) {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
  if (link) link.href = LOGO_SRC
  // iOS reads the apple-touch-icon tag (not the manifest) when adding to the home screen,
  // so a non-prod build has to retarget it here to keep its tier distinguishable
  const appleIcon = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]')
  if (appleIcon) appleIcon.href = `${APP_ICON_DIR}/apple-touch-icon.png`
}

// install the app shell worker; VersionWatcher listens for the update signal it raises
void registerPwa()

// recover from stale lazy-chunk fetch failures after a deploy
registerPreloadErrorReload()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex min-h-screen flex-col items-center justify-center gap-3">
          <p>Something went wrong.</p>
          <button className="underline" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      }
    >
      <QueryProvider>
        <App />
      </QueryProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
)
